import getInstance from "../config/api";

export default class Log {
  static async fetchLogs(params) {
    const instance = getInstance();
    const { data } = await instance.get("/log", { params });
    return data;
  }
  static async fetchDetailsLogs(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/log/${id}`);
    return data;
  }
  static async fetchLogsError(params) {
    const instance = getInstance();
    const { data } = await instance.get("/log/error", { params });
    return data;
  }
  static async downloadLogErrorsConsolidated(params) {
    const instance = getInstance();
    const data = await instance.get("/log/error-csv", { params });
    return data;
  }
  static async downloadLogs(params) {
    const instance = getInstance();
    const data = await instance.get("/log/csv", { params });
    return data;
  }
}
